// const getSrc = (m) => m.default as Record<string, unknown>;

export const config = {
  // disable - not working
  // DefaultLoader: () => import('./assets/loading_animationV4.json').then(getSrc),
  DefaultLoader: () => [],
};

export type AnimationMap = typeof config;
